// extracted by mini-css-extract-plugin
module.exports = {"container":"MicroCard_container__BxlWG","inline":"MicroCard_inline__VMiAf","micro":"MicroCard_micro__rJ431"};